import { render, staticRenderFns } from "./People.vue?vue&type=template&id=c05fcb8a&scoped=true&"
var script = {}
import style0 from "./People.vue?vue&type=style&index=0&id=c05fcb8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05fcb8a",
  null
  
)

export default component.exports